import PropTypes from 'prop-types'

import styles from './styles/SocialIcon.css'
import classNames from 'classnames'
import Link from './Link'

const SOCIAL = {
  x: {
    href: 'https://x.com/scite',
    icon: 'images/icons/social/x.svg'
  },
  linkedin: {
    href: 'https://www.linkedin.com/company/sciteai/',
    icon: 'images/icons/social/linkedin.svg'
  },
  facebook: {
    href: 'https://facebook.com/sciteai',
    icon: 'images/icons/social/facebook.svg'
  },
  instagram: {
    href: 'https://www.instagram.com/scite.ai/',
    icon: 'images/icons/social/instagram.svg'
  },
  youtube: {
    href: 'https://www.youtube.com/channel/UCso9-KdHZ6vfbYgM59zp9EA',
    icon: 'images/icons/social/youtube.svg'
  },
  tiktok: {
    href: 'https://www.tiktok.com/@scite.ai',
    icon: 'images/icons/social/tiktok.svg'
  }
}

function SocialIcon ({ type, href, className, ...rest }) {
  return (
    <Link className={classNames(styles.socialIcon, className)} href={href || SOCIAL[type].href} target='_blank' rel='noopener noreferrer' {...rest} aria-label={SOCIAL[type].href + ' (opens in a new tab)'}>
      <img src={`${CONFIG.assetsBaseURL}/${SOCIAL[type].icon}`} alt={`social icon for ${type}`} />
    </Link>
  )
}

SocialIcon.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.oneOf(['facebook', 'x', 'linkedin', 'instagram', 'youtube', 'tiktok'])
}
export default SocialIcon
